import { useCallback } from "react";
import { IOpenPanel } from "../../../Interfaces/IPanel";
import { IFormularioHazard } from "../../../Interfaces/hazard/IHazard";
import { PanelDrawer } from "../../../components/Panel/PanelDrawer";
import { PanelFooter } from "../../../components/Panel/PanelFooter";
import { UsePanelHazardConfirmacion } from "./UsePanelHazardConfirmacion";
import { Body1, makeStyles } from "@fluentui/react-components";
import { Warning24Filled } from "@fluentui/react-icons";
export interface IPanelHazardConfirmacion extends IOpenPanel{
    request: IFormularioHazard
}
const useStyles = makeStyles({
    container: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignContent: "center",
      top: "100%",
      alignItems: "center",
    },
  
    warning: {
      color: " #eaa300",
      width: "60px",
      height: "60px",
    },
  });
export const PanelHazardConfirmacion=(props:IPanelHazardConfirmacion)=>{
    const  {status,mensaje,loading,Registrar,reset} = UsePanelHazardConfirmacion(props)
    const styles = useStyles();
    const onRenderFooter = useCallback(
        () => (
          <>
            <PanelFooter
              texto="Confirmar"
              texto2={"Salir"}
              //disableButton={disableForm}
              onClick={Registrar}
              onDismiss={() => {
                reset()
              }}
            />
          </>
        ),
        [props.request]
      );
     
    return (
        <PanelDrawer isOpen={props.isOpen} onDismiss={reset} textHeader={"Confirmación de registro de formulario"} 
        status={status} mensaje={mensaje} loading={loading} onRenderFooter={onRenderFooter}>
             <div className={styles.container}>
                      <div>
                        <Warning24Filled className={styles.warning} />
                      </div>
                      <div>
                        <Body1>
                        ¿Desea
                          registrar el incidente con la información colocada?
                        </Body1>
                      </div>
                    </div>
         </PanelDrawer>
        )
}